'use client';

import React, { useState, useEffect } from 'react';
import styles from '../../styles/MiniPresaleCTA.module.css';
import { ClientPurchaseModal } from '../ClientPurchaseModal'; // Corrected path

const ShoppingBagIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 0 1-8 0"/>
    </svg>
);

const MiniPresaleCTA = () => {
    const [presaleStatus, setPresaleStatus] = useState({
        tokenPrice: null,
        isActive: false,
        isLoading: true,
        error: null,
    });
    const [showPurchaseModal, setShowPurchaseModal] = useState(false);

    useEffect(() => {
        const fetchPresaleData = async () => {
            try {
                const response = await fetch('/api/presale/progress'); // Changed to use the same route as PresaleProgress
                if (!response.ok) {
                    throw new Error(`Failed to fetch presale data: ${response.status}`);
                }
                const result = await response.json();
                if (result.success && result.data) {
                    const endDate = new Date(result.data.presaleEndDate);
                    const now = new Date();
                    const active = endDate > now && result.data.tokensRemaining > 0;
                    
                    setPresaleStatus({
                        tokenPrice: result.data.tokenPrice || null,
                        isActive: active,
                        isLoading: false,
                        error: null,
                    });
                } else {
                    throw new Error(result.message || 'Failed to get presale data');
                }
            } catch (error) {
                console.error("Error fetching presale data:", error);
                setPresaleStatus({
                    tokenPrice: null,
                    isActive: false,
                    isLoading: false,
                    error: error.message || 'Could not load presale information.',
                });
            }
        };

        fetchPresaleData();
    }, []);

    const handleBuyClick = () => {
        setShowPurchaseModal(true);
    };

    if (presaleStatus.isLoading) {
        return (
            <div className={`${styles.miniPresaleCta} ${styles.loadingContainer}`}>
                <div className={styles.loadingSpinner}></div>
                <p>Loading Presale Info...</p>
            </div>
        );
    }

    if (presaleStatus.error) {
        return (
            <div className={`${styles.miniPresaleCta} ${styles.errorContainer}`}>
                <p className={styles.errorMessage}>Error: {presaleStatus.error}</p>
                <p>Please try again later.</p>
            </div>
        );
    }

    if (!presaleStatus.isActive) {
        return (
            <div className={styles.miniPresaleCta}>
                 <div className={styles.header}>
                    <span className={styles.icon}>💰</span>
                    <h3 className={styles.title}>GAM Token Presale</h3>
                </div>
                <p className={styles.info}>The presale is not currently active or all tokens have been sold. Check back soon!</p>
            </div>
        );
    }

    return (
        <div className={styles.miniPresaleCta}>
            <div className={styles.header}>
                <span className={styles.icon}>🚀</span>
                <h3 className={styles.title}>GAM Token Presale is Live!</h3>
            </div>
            <div className={styles.content}>
                <p className={styles.info}>
                    Current Price: <span className={styles.price}>${presaleStatus.tokenPrice ? presaleStatus.tokenPrice.toFixed(3) : 'N/A'} USD</span>
                </p>
                <p className={styles.info}>Don't miss out on acquiring GAM tokens at the presale rate.</p>
            </div>
            <button className={styles.buyButton} onClick={handleBuyClick}>
                <ShoppingBagIcon />
                Buy GAM Tokens Now
                <span className={styles.buttonGlow}></span>
            </button>

            <ClientPurchaseModal 
                isOpen={showPurchaseModal} 
                onClose={() => setShowPurchaseModal(false)} 
                // projectUsdtWalletAddress={process.env.NEXT_PUBLIC_MOONPAY_PROJECT_USDC_WALLET_ADDRESS}
            />
        </div>
    );
};

export default MiniPresaleCTA; 